import { Drawer } from '@material-ui/core';
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import WebPolling from './webPolling';
import WebQA from './webQA';
import WebChat from './webChat';
import Speaker from '../MeetingDrawer/speaker/speaker';
import BroadcastChat from '../MeetingDrawer/BroadcastChat/BroadcastChat';
import PollsResult from '../MeetingDrawer/polling/pollsResult/pollsResult';

const useStyles = makeStyles((theme) => ({
	drawerPaper : {
		width                          : '30vw',
		height                         : '100%',
		[theme.breakpoints.down('lg')] :
		{
			width : '30vw'
		},
		[theme.breakpoints.down('md')] :
		{
			width : '40vw'
		},
		[theme.breakpoints.down('sm')] :
		{
			width : '100vw'
		},
		[theme.breakpoints.down('xs')] :
		{
			width : '100vw'
		}
	}

}));

function WebSideBar(props)
{
	const { open, sideComp, setSideComp, handleClose } = props;
	const classes = useStyles();

	const urlParser = new URL(window.location);

	const parameters = urlParser.searchParams;

	const sessionId = parameters.get('sessionId');

	const [ isPlaying, setIsPlaying ] = useState(false);
	const [ preview, setPreview ] = useState(false);
	const [ fileUrl, setFileUrl ] = useState({});

	return (
		<Drawer open={open} anchor='right' onClose={handleClose} classes={{ paper: classes.drawerPaper }} >
			{ sideComp === 'poll' ? <WebPolling setSideComp={setSideComp} handleClose={handleClose}/> :
				sideComp === 'qa' ? <WebQA setSideComp={setSideComp} handleClose={handleClose}/> :
					sideComp === 'chat' ? <BroadcastChat webinarUser sessionId={sessionId} handleClose={handleClose} isPlaying={isPlaying} setIsPlaying={setIsPlaying} preview={preview} setPreview={setPreview} setFileUrl={setFileUrl} fileUrl={fileUrl}/> :
						sideComp === 'speaker' ? <Speaker setSideComp={setSideComp} handleClose={handleClose}/> :
							sideComp === 'pollResult' ? <PollsResult webinarUser setSideComp={setSideComp} handleClose={handleClose} />
								: ''}
		</Drawer>
	);
}

export default WebSideBar;